export default __webpack_public_path__ + "view-support-card.c68ec65.jpg";